import { api } from 'directual';


export function getUser(username) {
  return api
    .structure('WebUser')
    .search({ filters: [{ field: 'id', value: username, exp: '==' }] })
    .then(response => response.result.list[0].obj);
}



// WEBPACK FOOTER //
// ./src/Auth/utils/http.js